import axios from "axios";
import config from "_config/config"
import variables from "_constants/variables";
import { notification } from "antd";
import localOrSessionStore from "_helpers/localOrSessionStore";

const storage = localOrSessionStore({ key: variables.REMEMBER });

export const axiosInstance = axios.create();
let sessionExpiredShown = false;

/* ===========================
    REQUEST INTERCEPTOR
=========================== */
axiosInstance.interceptors.request.use(
  (config) => {
    const token = storage.getItem(variables.TOKEN);

    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* ===========================
    RESPONSE INTERCEPTOR
=========================== */
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (!error.response) {
      return Promise.reject(error);
    }

    const originalRequest = error.config;
    const refreshToken = storage.getItem(variables.TOKENREFRESH);
    const user = JSON.parse(storage.getItem(variables.USER));
    const userType = storage.getItem(variables.USER_TYPE);

    /* ================
      REFRESH TOKEN
    =================== */
    if (error.response.status === 498 && refreshToken && !originalRequest._retry) {

      originalRequest._retry = true;

      try {
        const { data } = await axios.post(
          `${config.backendUrl}/v1/${
            userType === "STUDENT" ? "student" :
            userType === "MASTER" ? "master" : "tutor"
          }/auth/refresh`,
          {
            refreshToken,
            username: user.email,
          }
        );

        storage.setItem(variables.TOKEN, data.data.token);
        storage.setItem(variables.TOKENREFRESH, data.data.refreshToken);

        //  actualizar axios global
        axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${data.data.token}`;
        // Actualizar request original y repetirlo
        originalRequest.headers.Authorization = `Bearer ${data.data.token}`;

        return axiosInstance(originalRequest);

      } catch (e) {
        // Pasará a sesión expirada
      }
    }

    /* ============================
        SESIÓN EXPIRADA
    ============================ */
    if ((error.response.status === 498 || error.response.status === 401) && !sessionExpiredShown) {

      sessionExpiredShown = true;

      notification.error({
        message: "Sesión expirada",
        description: "Tu sesión ha vencido. Por favor, vuelve a iniciar sesión.",
        duration: 1.5,
        placement: "topRight",
        onClose: () => {
          storage.removeItem(variables.TOKEN);
          storage.removeItem(variables.TOKENREFRESH);
          storage.removeItem(variables.USER);
          storage.removeItem(variables.USER_TYPE);
          window.location.href = "/auth/login";
        }
      });

      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);
